const createMockFunction = () =>
  typeof jest !== 'undefined'
    ? jest.fn().mockImplementation(() => Promise.resolve({}))
    : () => Promise.resolve({});

const mockRequestDelete = createMockFunction()
const mockRequestGet = createMockFunction()
const mockRequestPost = createMockFunction()
const mockRequestPut = createMockFunction()

export {
  mockRequestDelete,
  mockRequestGet,
  mockRequestPost,
  mockRequestPut,
}
